module.exports = Object.freeze({
  COMPANY: "CÔNG TY CỔ PHẦN NƯỚC SẠCH SỐ 2 HÀ NỘI",
  COMAPNT_EN: "HANOI WATER SUPPLY NUMBER 2 JOINT STOCK COMPANY",
});
